import {Icon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "60",
  height: "20",
  viewBox: "0 0 60 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<circle fill=\"currentColor\" cx=\"6\" cy=\"6\" r=\"6\"><animate attributeName=\"opacity\" dur=\"1s\" values=\"0;1;0\" repeatCount=\"indefinite\" begin=\".1\"></animate></circle><circle fill=\"currentColor\" cx=\"26\" cy=\"6\" r=\"6\"><animate attributeName=\"opacity\" dur=\"1s\" values=\"0;1;0\" repeatCount=\"indefinite\" begin=\".2\"></animate></circle><circle fill=\"currentColor\" cx=\"46\" cy=\"6\" r=\"6\"><animate attributeName=\"opacity\" dur=\"1s\" values=\"0;1;0\" repeatCount=\"indefinite\" begin=\".3\"></animate></circle>", 3)
  ]))]))
}
export default { render() { return h(Icon, {icon: {render}, name: "icon-is-typing"}) } }